import { format } from 'date-fns';

export const getWeekdayFromDate = (date: Date) => {
  return format(date, 'EEEE');
};

//  returns the user's timezone in the format of 'America/New_York'
export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
